// ** MUI Imports
import Divider from '@mui/material/Divider'
import CardContent from '@mui/material/CardContent'

const TabStatistics = () => {
    return (
        <form>
            <CardContent sx={{ pb: 0 }}>
                Statistics
            </CardContent>
        </form>
    )
}
export default TabStatistics
